import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/reset.css";
import "./styles/afaq-brand.css";
import "./styles/tokens.css";
import "./styles/layout.css";
import "./styles/components.css";
import "./styles/mega-menu.css";
import "./styles/attendance.css";
import "./styles/crm.css";
import "./styles/majestic.css";
import "./styles/mobile-fixes.css";  // FIX C 2026-05-17 — must load last
import "./styles/login-fixes.css";  // FIX D 2026-05-17 — brand alignment for /login

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
